import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation MakeUserBasic($teamId: ID!, $userId: ID!) {
    makeUserBasic(teamId: $teamId, userId: $userId)
  }
`

export const makeUserBasicKey = getQueryNames(query)[0]

export default query
